<template>
  <tour
    root-element-selector="#accounts-select"
    title="Поздравляем! Новый аккаунт успешно создан"
    :offset-top="68"
    :offset-left="-80"
    @close="onClose"
  >
    <template #text> <b>Важно знать!</b> Вы можете создавать 2 и более аккаунтов и переключаться между ними. </template>
    <template #arrow>
      <v-img :src="Arrow" width="50" class="arrow" />
    </template>
  </tour>
</template>

<script setup lang="ts">
import Arrow from '@/assets/img/pages/object/arrow1.svg';
import Tour from '@/core/components/common/Tour.vue';
import { useTourStore } from '@/core/store/tour';

const { setActiveTour } = useTourStore();

const onClose = () => {
  setActiveTour('tariffsTour');
};
</script>

<style scoped lang="scss">
.arrow {
  position: absolute;
  bottom: calc(100% + 8px);
}
</style>
